import { jsx as _jsx } from "react/jsx-runtime";
import { HEADER_HEIGHT } from '../header';
import { Map } from '../map';
import { NAV_CONTAINER_HEIGHT } from '../nav';
export const BroadcastAreaMap = (props) => {
    return (_jsx(Map, { ...props, height: `calc(100vh - ${HEADER_HEIGHT}px - ${NAV_CONTAINER_HEIGHT}px)` }));
};
